import errorResponseHandler from '@data/helpers/errorResponseHandler';
import authAxios from '@services/authAxios';

const fetchCustomerGroup = async ({ queries }) => {
    try {
        const { data } = await authAxios.get(`api/v1/master-data/customer-group${queries}`);
        return data?.data;
    } catch (error) {
        const errorMessage = errorResponseHandler(error);
        throw new Error(errorMessage);
    }
};

export default fetchCustomerGroup;
